import { Injectable, OnDestroy, inject } from '@angular/core';

import { Subscription } from 'rxjs';

import { Store } from '@ngrx/store';

import { tokenFeature } from '../app/store/token.feature';

@Injectable({
  providedIn: 'root',
})
export class TokenService implements OnDestroy {
  private store: Store = inject(Store);
  private tokenString: string | null = null;
  private readonly subscription: Subscription;

  constructor() {
    console.log('[TokenService] Initializing...');

    // Check local storage directly for debugging
    const localToken = localStorage.getItem('authentication');
    console.log(`[TokenService] Local storage token: ${localToken ? 'exists' : 'not found'}`);

    // Subscribe to store updates
    this.subscription = this.store.select(tokenFeature.selectTokenString).subscribe((tokenString) => {
      console.log(`[TokenService] Token updated from store: ${tokenString ? 'token present' : 'no token'}`);
      this.tokenString = tokenString;
    });
  }

  public ngOnDestroy(): void {
    console.log('[TokenService] Destroying service');
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public getToken(): string | null {
    // Check if we should fetch directly from localStorage
    if (!this.tokenString) {
      const localToken = localStorage.getItem('authentication');
      console.log(`[TokenService] getToken() - Local storage direct check: ${localToken ? 'token found' : 'no token'}`);

      if (localToken) {
        return localToken;
      }
    }

    console.log(`[TokenService] getToken() returning: ${this.tokenString ? 'token present' : 'no token'}`);
    return this.tokenString;
  }
}
